import './pilotage-details.css';
import Spacer from '../../../components/layout/Spacer';
import PilotagePecExamsInfo from './PilotagePecExamsInfo';
import PilotageDetailLocation from './PilotageDetailLocation';
import PilotageDetailsAssignment from './PilotageDetailsAssignment';
import PilotageDetailsTransportOrders from './PilotageDetailsTransportOrders';
import { MiniCard } from '../../../components/layout/card/MiniCard';
import { isNullOrEmpty } from '../../../components/helpers/ObjectHelpers';
import { getPilotAssignmentStatusColor } from '../pilot-assignment/helpers/PilotAssignmentHelpers';
import ContentGrid from '../../../components/layout/ContentGrid';
import { Card } from '../../../components/layout/card/Card';
import { useEffect, useState } from 'react';
import SourceApiRepository from '../../../repositories/api/SourceApiRepository';
import { isAspiringPilotAndNotAssignedToPilotAssignment } from '../pilot-assignment/helpers/PilotAssignmentHelpers';
import AspiringPilotDetail from './AspiringPilotDetail';

export default function PilotageDetailsDefault({ onReload, state: pilotage, isReadOnly }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        const getWhoAmI = async () => {
            const response = await SourceApiRepository.getWhoAmIAsync();
            const result = await response.json();
            setData(() => ({
                whoAmI: result
            }));
        };
        getWhoAmI();
    }, [onReload]);
    return (
        <ContentGrid
            title={pilotage.pilotageShip.shipName}
            subTitle={pilotage.pilotageNo}
            canCopySubTitle={true}
            titleIcon="ship">
            <div className="details-content">
                <PilotageDetailLocation
                    state={pilotage}
                    isReadOnly={isReadOnly}
                />
                {
                    !(isNullOrEmpty(pilotage.pilotageDetail.remark) &&
                        isNullOrEmpty(pilotage.pilotageDetail.dispatcherRemark)) &&
                    <Card>
                        {
                            !isNullOrEmpty(pilotage.pilotageDetail.remark) &&
                            <>
                                <div className="details-card-title font-size-lg">Oppdragsmerknad</div>
                                <div>{pilotage.pilotageDetail.remark}</div>
                                <Spacer height={10} />
                            </>
                        }
                        {
                            !isNullOrEmpty(pilotage.pilotageDetail.dispatcherRemark) &&
                            <>
                                <div className="details-card-title font-size-lg">Melding fra losformidler</div>
                                <div>{pilotage.pilotageDetail.dispatcherRemark}</div>
                            </>
                        }
                    </Card>
                }


                <PilotageDetailsTransportOrders
                    pilotageId={pilotage.pilotageId}
                    handleUpdate={onReload}
                    isReadOnly={isReadOnly}
                />

                {(!isNullOrEmpty(pilotage.pilotagePilotsInformation) ||
                    !isNullOrEmpty(pilotage.assistancePhone)) &&
                    <Card>
                        {!isNullOrEmpty(pilotage.pilotagePilotsInformation) &&
                            <>
                                <div className="details-card-title font-size-lg">
                                    {pilotage?.pilotagePilotsInformation && "Loser"}
                                </div>
                            </>
                        }
                        {!isNullOrEmpty(pilotage.pilotagePilotsInformation) &&
                            pilotage?.pilotagePilotsInformation?.map((pilot, index) =>
                                <div key={index} className="pilot-container">
                                    <MiniCard
                                        item={{
                                            borderColor: getPilotAssignmentStatusColor(pilot),
                                            text: `${pilot.lastName} ${pilot.initials}`,
                                            isExaminer: pilot.isExaminer,
                                            isTrainee: pilot.isTrainee,
                                            isApprentice: pilot.isApprentice
                                        }}
                                    />
                                    <a href={`tel: ${pilot.phoneNumber}`} className="pilot-phone-link">
                                        {`${pilot.phoneNumber}`}
                                    </a>
                                </div>
                            )
                        }
                        {
                            !isNullOrEmpty(pilotage.assistancePhone) &&
                            <>
                                <Spacer height={15} />
                                <div>
                                    <div className="details-card-title font-size-lg">
                                        Vakttelefon agent
                                    </div>
                                    <a href={`tel: ${pilotage.assistancePhone}`} className="phone-link">
                                        {`${pilotage.assistancePhone}`}
                                    </a>
                                </div>
                            </>
                        }
                    </Card>
                }
                {
                    !isNullOrEmpty(pilotage.pecExams) &&
                    <Card title="Farledspr&oslash;ve">
                        <div className="details-card">
                            {
                                pilotage.pecExams.map((pec, index) =>
                                    <div key={index}>
                                        <PilotagePecExamsInfo
                                            pecExam={pec}
                                            pilotageId={pilotage.pilotageId}
                                        />
                                    </div>
                                )
                            }
                        </div>
                    </Card>
                }
                {
                    isReadOnly && data && isAspiringPilotAndNotAssignedToPilotAssignment(data.whoAmI, pilotage?.pilotagePilotsInformation) &&
                    <AspiringPilotDetail
                        pilotageId={pilotage.pilotageId}
                    />
                }
                {
                    !isReadOnly &&
                    <PilotageDetailsAssignment
                        pilotageId={pilotage.pilotageId}
                        updatePilotagePilot={onReload}
                        pilotagePilotsInformation={pilotage.pilotagePilotsInformation}
                    />
                }
            </div>
            <Spacer height={30} />
        </ContentGrid>
    )
}
